import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh',
    fallbackLng: 'zh',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// Set initial html lang attribute
const langMap: Record<string, string> = { zh: 'zh-CN', en: 'en', ru: 'ru' };
document.documentElement.lang = langMap[i18n.language] || 'zh-CN';

export default i18n;